/* Página de produto em kit (fl-lp-*) — montador em 3 passos: kit → peças (cor + tamanho) → resumo e compra. */
(function () {
  if (window.FlLp) return;

  var brl = function (cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var track = function (event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Até 5x sem juros, parcela mínima R$ 50
  var installments = function (cents) {
    var n = Math.max(1, Math.min(5, Math.floor(cents / 5000)));
    return n + 'x de ' + brl(Math.round(cents / n)) + ' sem juros';
  };
  var ICON = {
    tick: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9M12 8v13"/><path d="M12 8S10.5 3 8 4.5 9.5 8 12 8Zm0 0s1.5-5 4-3.5S14.5 8 12 8Z"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>'
  };

  function Main(el) {
    this.el = el;
    this.data = JSON.parse(el.querySelector('[data-fl-data]').textContent);
    var lists = this.data.lists;
    // Preço de referência = 1º produto configurado em cada lista (antes de filtrar estoque)
    var ref = this.ref = {};
    var refCompare = this.refCompare = {};
    Object.keys(lists).forEach(function (k) {
      ref[k] = lists[k].products.length ? lists[k].products[0].price : 0;
      refCompare[k] = lists[k].products.length ? Math.max(lists[k].products[0].compare || 0, ref[k]) : 0;
      // Só cores com estoque
      lists[k].products = lists[k].products.filter(function (p) { return p.available; });
    });
    // Produto aberto: vira a 1ª cor se já estiver numa lista; fora das listas, só entra na lista A se for
    // o mesmo modelo (título começa com o nome da lista, ex. "Macaquinho Vestido …" — cor nova ainda não listada).
    // Qualquer outro produto (ex. prévia do editor abrindo uma calça) é ignorado.
    var cur = this.data.current;
    this.currentId = null;
    if (cur && cur.available) {
      var inAny = Object.keys(lists).some(function (k) { return lists[k].products.some(function (p) { return p.id === cur.id; }); });
      var norm = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); };
      var sameModel = lists.a && norm(lists.a.label) && norm(cur.title).indexOf(norm(lists.a.label)) === 0;
      if (!inAny && sameModel) lists.a.products.unshift(cur);
      if (inAny || sameModel) this.currentId = cur.id;
    }
    this.data.gift.products = this.data.gift.products.filter(function (p) { return p.available && p.variant.a; });
    this.data.addon = this.data.addon || { products: [] };
    this.data.addon.products = (this.data.addon.products || []).filter(function (p) { return p.available && p.variant.a; });
    this.addonOn = false;
    this.addonIdx = 0;
    this.offers = this.data.offers.filter(function (o) {
      return o.slots.length && o.slots.every(function (k) { return lists[k] && lists[k].products.length; });
    });
    this.offers.forEach(this.price, this);
    this.picks = [];
    this.open = 0;
    this.hasGuide = !!el.querySelector('[data-fl-guide]');
    this.guideFor = -1;
    this.giftIdx = 0;
    var builder = el.querySelector('[data-fl-flow]');
    this.flow = !!builder && builder.dataset.flFlow === 'friendly';
    this.stage = { t: 'kit' };
    this.gallery();
    this.bind();
    this.renderFrom();
    var start = this.offers.filter(function (o) { return o.id === this.data.defaultOffer; }, this)[0] || this.offers[0];
    if (start) this.select(start.id, true);
    if (this.flow) this.bindFlow();
    this.sticky();
    this.guide();
    this.dispatch();
  }

  // Preço fixo do kit: soma dos preços de referência − desconto
  Main.prototype.price = function (o) {
    var ref = this.ref;
    var sum = o.slots.reduce(function (acc, k) { return acc + (ref[k] || 0); }, 0);
    o.pieces = sum;
    o.total = Math.round(sum * (100 - o.discount) / 100);
    var refCompare = this.refCompare;
    // 1 peça sem desconto: o "de" é o preço comparativo do produto
    var base = (o.slots.length === 1 && !o.discount) ? o.slots.reduce(function (acc, k) { return acc + (refCompare[k] || 0); }, 0) : sum;
    o.old = base + (o.gift && this.data.gift.value ? this.data.gift.value : 0);
    o.save = o.old - o.total;
    o.pct = o.old ? Math.round(o.save * 100 / o.old) : 0;
  };

  Main.prototype.offer = function () {
    var id = this.offerId;
    return this.offers.filter(function (o) { return o.id === id; })[0];
  };

  Main.prototype.q = function (sel) { return this.el.querySelector(sel); };

  Main.prototype.bind = function () {
    var self = this;
    this.el.querySelectorAll('[data-fl-offer]').forEach(function (btn) {
      var ok = self.offers.some(function (o) { return o.id === btn.dataset.flOffer; });
      if (!ok) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        self.select(btn.dataset.flOffer);
        if (self.flow) setTimeout(function () { self.go({ t: 'piece', i: 0, ph: 'color' }); }, 220);
      });
    });
    this.q('[data-fl-buy]').addEventListener('click', function () { self.buy(); });
    var addCart = this.q('[data-fl-addcart]');
    if (addCart) addCart.addEventListener('click', function () { self.buy('cart'); });
    this.q('[data-fl-pieces]').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      var piece = b.closest('[data-fl-piece]');
      var i = +piece.dataset.flPiece;
      var pick = self.picks[i];
      var list = self.data.lists[pick.key];
      if (b.hasAttribute('data-guide')) {
        self.openGuide(i);
        return;
      }
      if (b.dataset.same != null) {
        self.applySize(b.dataset.same);
        track('size_same_all', { size: b.dataset.same });
        return;
      }
      if (b.dataset.phase) {
        self.go({ t: 'piece', i: i, ph: b.dataset.phase });
        return;
      }
      if (b.hasAttribute('data-toggle')) {
        if (self.flow) return;
        self.open = self.open === i ? -1 : i;
        self.renderPieces();
        return;
      }
      if (b.dataset.group != null) {
        pick.group = b.dataset.group;
        var first = self.firstIdx(list, pick.group, 0, null);
        if (first > -1) { pick.p = first; pick.v = null; }
      } else if (b.dataset.p != null) {
        var prev = list.products[pick.p];
        pick.p = +b.dataset.p;
        // Mantém o tamanho se existir e tiver estoque na nova cor
        var size = prev && pick.v != null ? prev.variants.filter(function (v) { return v.id === pick.v; })[0] : null;
        var same = size ? list.products[pick.p].variants.filter(function (v) { return v.t === size.t && v.a; })[0] : null;
        pick.v = same ? same.id : null;
        track('color_select', { piece: i + 1, product: list.products[pick.p].title });
        if (self.flow) {
          self.renderKit();
          if (i === 0) self.updateGallery();
          setTimeout(function () { self.go({ t: 'piece', i: i, ph: 'size' }); }, 180);
          self.renderPieces();
          return;
        }
      } else if (b.dataset.v != null) {
        pick.v = +b.dataset.v;
        pick.missing = false;
        track('size_select', { piece: i + 1, size: b.textContent.trim() });
        if (self.flow) {
          self.renderPieces();
          self.renderKit();
          self.hideError();
          setTimeout(function () { self.next(); }, 220);
          return;
        }
        // Avança para a próxima peça sem tamanho
        var next = self.picks.findIndex(function (p) { return p.v == null; });
        self.open = next;
        self.renderPieces();
        self.renderKit();
        self.hideError();
        if (next > -1) {
          var el = self.q('[data-fl-piece="' + next + '"]');
          if (el && el.getBoundingClientRect().top > window.innerHeight * 0.75) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      self.renderPieces();
      self.renderKit();
      if (i === 0) self.updateGallery();
    });
    this.q('[data-fl-gift]').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-g]');
      if (!b) return;
      self.giftIdx = +b.dataset.g;
      self.renderGift();
      self.renderKit();
      if (self.flow) setTimeout(function () { self.go({ t: 'review' }); }, 220);
    });
    var addon = this.q('[data-fl-addon]');
    if (addon) addon.addEventListener('click', function (e) {
      var c = e.target.closest('button[data-a]');
      var t = e.target.closest('[data-fl-addon-toggle]');
      if (c) { self.addonIdx = +c.dataset.a; self.addonOn = true; }
      else if (t) self.addonOn = !self.addonOn;
      else return;
      track(self.addonOn ? 'addon_add' : 'addon_remove', { offer: self.offer().title });
      self.renderAddon();
      self.renderKit();
    });
  };

  // Tamanho já escolhido que ainda falta em outras peças (com estoque nelas): oferece "usar em todas"
  Main.prototype.sameSize = function (i) {
    var self = this;
    var own = this.variantOf(this.picks[i]);
    var ref = own || this.picks.map(function (p) { return self.variantOf(p); }).filter(Boolean)[0];
    if (!ref || this.picks.length < 2) return null;
    var fits = this.picks.some(function (p, j) {
      if (j === i && own) return false;
      if (p.v != null) return false;
      var prod = self.data.lists[p.key].products[p.p];
      return prod && prod.variants.some(function (v) { return v.t === ref.t && v.a; });
    });
    return fits ? ref.t : null;
  };

  Main.prototype.applySize = function (t) {
    var self = this;
    this.picks.forEach(function (p) {
      if (p.v != null) return;
      var prod = self.data.lists[p.key].products[p.p];
      var v = prod && prod.variants.filter(function (x) { return x.t === t && x.a; })[0];
      if (v) { p.v = v.id; p.missing = false; }
    });
    this.open = this.picks.findIndex(function (p) { return p.v == null; });
    if (this.flow) {
      var after = this.stages().filter(function (st) { return st.t !== 'kit' && st.t !== 'piece'; })[0];
      this.renderKit();
      this.go(this.open > -1 ? { t: 'piece', i: this.open, ph: 'size' } : after);
      return;
    }
    this.renderPieces();
    this.renderKit();
    this.hideError();
  };

  // Índice do n-ésimo produto da lista (filtrado pelo modelo), começando pelo produto aberto
  Main.prototype.firstIdx = function (list, group, n, preferId) {
    var idx = [];
    list.products.forEach(function (p, j) { if (!group || p.group === group) idx.push(j); });
    if (!idx.length) return -1;
    if (preferId) {
      var at = idx.filter(function (j) { return list.products[j].id === preferId; })[0];
      if (at != null) idx = [at].concat(idx.filter(function (j) { return j !== at; }));
    }
    return idx[Math.min(n, idx.length - 1)];
  };

  Main.prototype.select = function (id, silent) {
    var self = this;
    this.offerId = id;
    var o = this.offer();
    var seen = {};
    this.picks = o.slots.map(function (key, i) {
      var n = seen[key] = (seen[key] == null ? 0 : seen[key] + 1);
      var prev = self.picks[i];
      if (prev && prev.key === key) return prev;
      var list = self.data.lists[key];
      var preferId = self.currentId;
      var cur = preferId && list.products.filter(function (p) { return p.id === preferId; })[0];
      var group = cur ? cur.group : (list.groups.length ? list.groups[0] : '');
      return { key: key, group: group, p: self.firstIdx(list, group, n, preferId), v: null };
    });
    var missing = this.picks.findIndex(function (p) { return p.v == null; });
    this.open = missing;
    this.el.querySelectorAll('[data-fl-offer]').forEach(function (b) {
      b.setAttribute('aria-checked', String(b.dataset.flOffer === id));
    });
    var desc = this.q('[data-fl-offer-desc]');
    desc.textContent = o.desc || '';
    desc.hidden = !o.desc;
    this.renderPieces();
    this.renderGift();
    this.renderAddon();
    this.renderKit();
    this.updateGallery();
    this.hideError();
    if (this.flow && this.stage.t !== 'kit') {
      var m = this.picks.findIndex(function (p) { return p.v == null; });
      this.go(m > -1 ? { t: 'piece', i: m, ph: 'color' } : { t: 'review' });
    }
    if (!silent) track('select_offer', { offer: o.title, value: o.total / 100 });
  };

  // ---------- Modo guiado (Friendly): uma escolha por vez ----------
  Main.prototype.stages = function () {
    var o = this.offer();
    var list = [{ t: 'kit' }];
    this.picks.forEach(function (p, i) { list.push({ t: 'piece', i: i }); });
    if (o && o.gift && this.data.gift.products.length > 1) list.push({ t: 'gift' });
    list.push({ t: 'review' });
    return list;
  };

  Main.prototype.stageIdx = function () {
    var st = this.stage;
    return this.stages().findIndex(function (x) { return x.t === st.t && (x.t !== 'piece' || x.i === st.i); });
  };

  Main.prototype.go = function (stage, force) {
    if (stage.t === 'piece') {
      if (!this.picks[stage.i]) stage = { t: 'review' };
      else { stage.ph = stage.ph || 'color'; this.open = stage.i; }
    }
    if (stage.t === 'review' && this.picks.some(function (p) { return p.v == null; }) && !force) {
      var m = this.picks.findIndex(function (p) { return p.v == null; });
      stage = { t: 'piece', i: m, ph: 'size' };
      this.open = m;
    }
    if (stage.t === 'review' || stage.t === 'kit') this.editing = false;
    this.stage = stage;
    var b = this.q('.fl-builder');
    b.classList.remove('is-anim');
    void b.offsetWidth;
    b.classList.add('is-anim');
    this.renderPieces();
    var top = b.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.6) window.scrollTo({ top: window.scrollY + top - 90, behavior: 'smooth' });
  };

  Main.prototype.next = function () {
    var st = this.stage;
    if (st.t === 'piece' && st.ph === 'color') return this.go({ t: 'piece', i: st.i, ph: 'size' });
    if (st.t === 'piece' && this.editing) return this.go({ t: 'review' });
    var list = this.stages();
    var nxt = list[this.stageIdx() + 1];
    if (nxt) this.go(nxt.t === 'piece' ? { t: 'piece', i: nxt.i, ph: 'color' } : nxt);
  };

  Main.prototype.back = function () {
    var st = this.stage;
    if (st.t === 'piece' && st.ph === 'size') return this.go({ t: 'piece', i: st.i, ph: 'color' });
    var list = this.stages();
    var prev = list[this.stageIdx() - 1];
    if (prev) this.go(prev.t === 'piece' ? { t: 'piece', i: prev.i, ph: 'size' } : prev, true);
  };

  Main.prototype.bindFlow = function () {
    var self = this;
    this.q('[data-fl-flowbar]').addEventListener('click', function (e) {
      if (e.target.closest('[data-fl-back]')) self.back();
    });
    this.q('[data-fl-flownav]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-fl-next]');
      if (b && !b.disabled) self.next();
    });
    this.q('[data-fl-kit]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-fl-edit]');
      if (!b) return;
      self.editing = true;
      self.go(b.dataset.flEdit === 'gift' ? { t: 'gift' } : { t: 'piece', i: +b.dataset.flEdit, ph: 'color' }, true);
    });
    this.renderFlow();
  };

  Main.prototype.renderFlow = function () {
    if (this.stage.t === 'piece' && !this.picks[this.stage.i]) this.stage = { t: 'review' };
    var st = this.stage;
    var o = this.offer();
    var list = this.stages();
    var idx = Math.max(0, this.stageIdx());
    var b = this.q('.fl-builder');
    b.dataset.stage = st.t;
    b.dataset.phase = st.t === 'piece' ? st.ph : '';
    var area = { kit: 'kit', piece: 'pieces', gift: 'pieces', review: 'review' }[st.t];
    this.el.querySelectorAll('[data-fl-stage]').forEach(function (s) { s.classList.toggle('is-active', s.dataset.flStage === area); });
    this.el.querySelectorAll('[data-fl-piece]').forEach(function (p) { p.classList.toggle('is-current', st.t === 'piece' && +p.dataset.flPiece === st.i); });

    var title = '';
    var sub = '';
    var pick = st.t === 'piece' ? this.picks[st.i] : null;
    var lst = pick ? this.data.lists[pick.key] : null;
    var prod = pick ? lst.products[pick.p] : null;
    var many = this.picks.length > 1;
    var stepTitle = function (sel) { var h = this.q(sel); return h ? h.textContent.trim() : ''; }.bind(this);
    if (st.t === 'kit') {
      title = stepTitle('[data-fl-stage="kit"] .fl-step__title') || 'Escolha seu kit';
      sub = stepTitle('[data-fl-stage="kit"] .fl-step__note');
    } else if (st.t === 'piece') {
      title = st.ph === 'color' ? 'Escolha a cor' : 'Escolha o tamanho';
      if (many) title = 'Peça ' + (st.i + 1) + ' de ' + this.picks.length + ': ' + title.toLowerCase();
      sub = lst.label + (st.ph === 'size' && prod ? ' · ' + prod.label : '');
    } else if (st.t === 'gift') {
      title = 'Escolha a cor do ' + this.data.gift.label.toLowerCase();
      sub = 'Vem de brinde no seu kit';
    } else {
      title = stepTitle('[data-fl-stage="review"] .fl-step__title') || 'Revise seu kit';
      sub = o.title + ' · tudo certo? É só finalizar.';
    }
    var pct = Math.round(((idx + 1) / list.length) * 100);
    var bar = this.q('[data-fl-flowbar]');
    bar.innerHTML = '<div class="fl-flow__top">' +
      '<button type="button" class="fl-flow__back" data-fl-back' + (idx === 0 && !(st.t === 'piece' && st.ph === 'size') ? ' hidden' : '') + '>' + ICON.chevron + '<span>Voltar</span></button>' +
      '<span class="fl-flow__count">Passo ' + (idx + 1) + ' de ' + list.length + '</span></div>' +
      '<div class="fl-flow__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>' +
      '<h2 class="fl-flow__title">' + esc(title) + '</h2>' + (sub ? '<p class="fl-flow__sub">' + esc(sub) + '</p>' : '');
    bar.hidden = false;

    var nav = this.q('[data-fl-flownav]');
    var label = '';
    var disabled = false;
    if (st.t === 'kit') label = 'Continuar com ' + o.title;
    else if (st.t === 'piece' && st.ph === 'color') label = 'Continuar com ' + (prod ? prod.label : 'esta cor');
    else if (st.t === 'piece') {
      disabled = pick.v == null;
      var nxt = list[idx + 1];
      label = disabled ? 'Escolha um tamanho' : (this.editing ? 'Voltar ao resumo' : (nxt && nxt.t === 'piece' ? 'Próxima peça' : 'Continuar'));
    } else if (st.t === 'gift') label = 'Continuar';
    nav.innerHTML = label ? '<button type="button" class="fl-flow-next" data-fl-next' + (disabled ? ' disabled' : '') + '><span>' + esc(label) + '</span>' + ICON.chevron + '</button>' : '';
    nav.hidden = !label;
  };

  Main.prototype.variantOf = function (pick) {
    var prod = this.data.lists[pick.key].products[pick.p];
    if (!prod || pick.v == null) return null;
    return prod.variants.filter(function (v) { return v.id === pick.v; })[0] || null;
  };

  Main.prototype.renderPieces = function () {
    var self = this;
    var done = this.picks.filter(function (p) { return p.v != null; }).length;
    var prog = this.q('[data-fl-progress]');
    prog.textContent = done + ' de ' + this.picks.length + (this.picks.length > 1 ? ' prontas' : ' pronta');
    prog.classList.toggle('is-done', done === this.picks.length);
    this.q('[data-fl-pieces]').innerHTML = this.picks.map(function (pick, i) {
      var list = self.data.lists[pick.key];
      var prod = list.products[pick.p];
      var variant = self.variantOf(pick);
      var isOpen = self.open === i;
      var cls = 'fl-piece' + (isOpen ? ' is-open' : '') + (variant ? ' is-done' : '') + (pick.missing ? ' is-missing' : '');
      var out = '<div class="' + cls + '" data-fl-piece="' + i + '">';
      out += '<button type="button" class="fl-piece__head" data-toggle aria-expanded="' + isOpen + '">';
      out += '<span class="fl-piece__num">' + (variant ? ICON.tick : (i + 1)) + '</span>';
      out += '<span class="fl-piece__thumb"><img src="' + esc(prod ? prod.thumb : '') + '" alt="" width="40" height="50"></span>';
      out += '<span class="fl-piece__txt"><span class="fl-piece__name">' + esc(list.label) + '</span>';
      out += '<span class="fl-piece__val">' + esc(prod ? prod.label : '') + ' · ' + (variant ? 'Tam. ' + esc(variant.t) : '<em>escolha o tamanho</em>') + '</span></span>';
      out += '<span class="fl-piece__chev">' + ICON.chevron + '</span></button>';
      out += '<div class="fl-piece__body"' + (isOpen ? '' : ' hidden') + '>';
      if (self.flow && prod) {
        out += '<button type="button" class="fl-chosen" data-phase="color"><img src="' + esc(prod.thumb) + '" alt="" width="36" height="45">' +
          '<span>Cor: <b>' + esc(prod.label) + '</b></span><em>trocar</em></button>';
      }
      if (list.groups.length > 1) {
        out += '<div class="fl-seg" role="radiogroup" aria-label="Modelo">';
        list.groups.forEach(function (g) {
          out += '<button type="button" role="radio" aria-checked="' + (pick.group === g) + '" data-group="' + esc(g) + '">' + esc(g) + '</button>';
        });
        out += '</div>';
      }
      out += '<p class="fl-label"><span class="fl-substep">1</span>Escolha a cor: <b>' + esc(prod ? prod.label : '') + '</b></p>';
      out += '<div class="fl-colors-wrap"><div class="fl-colors" role="radiogroup" aria-label="Cor da peça ' + (i + 1) + '">';
      list.products.forEach(function (p, j) {
        if (list.groups.length > 1 && p.group !== pick.group) return;
        out += '<button type="button" class="fl-color" role="radio" aria-checked="' + (j === pick.p) + '" data-p="' + j + '" aria-label="' + esc(p.label) + '" title="' + esc(p.label) + '">';
        out += '<span class="fl-color__img"><img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="56" height="70">' + ICON.tick + '</span><span class="fl-color__name">' + esc(p.label) + '</span></button>';
      });
      out += '</div><button type="button" class="fl-colors-more" hidden></button></div>';
      if (prod) {
        out += '<div class="fl-label-row"><p class="fl-label"><span class="fl-substep">2</span>Escolha o tamanho' + (variant ? ': <b>' + esc(variant.t) + '</b>' : '') + '</p>';
        if (self.hasGuide) out += '<button type="button" class="fl-size-help" data-guide>Qual é o meu tamanho?</button>';
        out += '</div>';
        out += '<div class="fl-sizes" role="radiogroup" aria-label="Tamanho da peça ' + (i + 1) + '">';
        prod.variants.forEach(function (v) {
          out += '<button type="button" class="fl-size' + (v.a && v.l ? ' is-low' : '') + '" role="radio" aria-checked="' + (v.id === pick.v) + '" data-v="' + v.id + '"' + (v.a ? '' : ' disabled aria-disabled="true" title="Esgotado"') + '>' + esc(v.t) + '</button>';
        });
        out += '</div>';
        var same = self.sameSize(i);
        if (same) out += '<button type="button" class="fl-same" data-same="' + esc(same) + '">' + ICON.tick + '<span>Usar tamanho <b>' + esc(same) + '</b> em todas as peças</span></button>';
        if (variant && variant.l && self.data.lowText) {
          out += '<p class="fl-low"><span class="fl-low__dot" aria-hidden="true"></span>' + esc(self.data.lowText.replace('[t]', variant.t)) + '</p>';
        }
      }
      return out + '</div></div>';
    }).join('');
    if (this.flow) this.renderFlow();
    this.hintScroll();
    this.renderPalette();
  };

  // Paleta de cores no topo (fora do montador): tocar troca a cor da 1ª peça da lista A e as fotos
  Main.prototype.renderPalette = function () {
    var self = this;
    var box = this.q('[data-fl-palette]');
    var list = this.data.lists.a;
    if (!box || !list || list.products.length < 2) return;
    if (!box.dataset.ready) {
      var max = +box.dataset.max || 8;
      var rest = list.products.length - max;
      box.innerHTML = '<p class="fl-palette__label"><b>' + list.products.length + ' cores</b><span data-fl-palette-name></span></p>' +
        '<div class="fl-palette__dots" role="radiogroup" aria-label="Cores">' +
        list.products.map(function (p, j) {
          return '<button type="button" class="fl-palette__dot' + (j >= max ? ' is-extra' : '') + '" role="radio" data-pal="' + j + '" aria-label="' + esc(p.label) + '" title="' + esc(p.label) + '"><img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="32" height="40"></button>';
        }).join('') +
        (rest > 0 ? '<button type="button" class="fl-palette__more" data-pal-more>+' + rest + '</button>' : '') + '</div>';
      box.dataset.ready = '1';
      box.hidden = false;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.hasAttribute('data-pal-more')) { box.classList.add('is-all'); b.hidden = true; return; }
        var i = self.picks.findIndex(function (p) { return p.key === 'a'; });
        var pick = self.picks[i];
        if (!pick) return;
        var prev = list.products[pick.p];
        var j = +b.dataset.pal;
        pick.p = j;
        if (list.products[j].group) pick.group = list.products[j].group;
        // Mantém o tamanho se existir e tiver estoque na nova cor
        var size = prev && pick.v != null ? prev.variants.filter(function (v) { return v.id === pick.v; })[0] : null;
        var same = size ? list.products[j].variants.filter(function (v) { return v.t === size.t && v.a; })[0] : null;
        pick.v = same ? same.id : null;
        self.renderPieces();
        self.renderKit();
        if (i === 0) self.updateGallery();
        track('palette_select', { product: list.products[j].title });
      });
    }
    var pick = this.picks.filter(function (p) { return p.key === 'a'; })[0];
    var active = pick ? pick.p : -1;
    box.querySelectorAll('[data-pal]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.pal === active)); });
    box.querySelector('[data-fl-palette-name]').textContent = active > -1 ? ' · ' + list.products[active].label : '';
  };

  // Carrossel de cores: na 1ª vez que aparece (e tem mais cores escondidas), as cores "puxam" para o lado
  // rapidinho, mostrando que dá para arrastar. Uma vez por peça; para se a cliente já mexeu.
  Main.prototype.hintScroll = function () {
    var self = this;
    this.hinted = this.hinted || {};
    if (this.hintIO) this.hintIO.disconnect();
    if (!('IntersectionObserver' in window)) return;
    this.hintIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var row = en.target;
        var key = row.getAttribute('aria-label');
        if (!en.isIntersecting || self.hinted[key]) return;
        if (row.scrollWidth - row.clientWidth < 8 || row.scrollLeft > 4) return;
        self.hinted[key] = true;
        self.hintIO.unobserve(row);
        setTimeout(function () {
          if (row.scrollLeft > 4) return;
          row.classList.add('is-nudge');
          setTimeout(function () { row.classList.remove('is-nudge'); }, 1700);
        }, 350);
      });
    }, { threshold: 0.7 });
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-fl-pieces] .fl-colors'), function (row) {
      if (self.hinted[row.getAttribute('aria-label')]) return;
      self.hintIO.observe(row);
      row.addEventListener('scroll', function () { self.hinted[row.getAttribute('aria-label')] = true; row.classList.remove('is-nudge'); }, { once: true, passive: true });
    });
    this.moreCount();
  };

  // Selo "+N cores" na ponta do carrossel: conta as cores que ainda estão escondidas à direita
  Main.prototype.moreCount = function () {
    Array.prototype.forEach.call(this.el.querySelectorAll('[data-fl-pieces] .fl-colors-wrap'), function (wrap) {
      var row = wrap.querySelector('.fl-colors');
      var badge = wrap.querySelector('.fl-colors-more');
      if (!row || !badge) return;
      var update = function () {
        if (!row.offsetParent) return;
        var edge = row.getBoundingClientRect().right - 16;
        var n = 0;
        Array.prototype.forEach.call(row.querySelectorAll('.fl-color'), function (c) {
          if (c.getBoundingClientRect().left + c.offsetWidth * 0.5 > edge) n++;
        });
        badge.hidden = n < 1;
        badge.textContent = '+' + n + (n === 1 ? ' cor' : ' cores');
        badge.setAttribute('aria-label', 'Ver mais ' + n + (n === 1 ? ' cor' : ' cores'));
      };
      var raf;
      row.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      badge.addEventListener('click', function (e) {
        e.stopPropagation();
        row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en, io) { if (en[0].isIntersecting) { update(); } }).observe(row);
      }
      update();
    });
  };

  Main.prototype.renderGift = function () {
    var o = this.offer();
    var wrap = this.q('[data-fl-gift]');
    var gifts = this.data.gift.products;
    if (!o.gift || !gifts.length) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    if (this.giftIdx >= gifts.length) this.giftIdx = 0;
    var g = gifts[this.giftIdx];
    var out = '<div class="fl-gift__head"><span class="fl-gift__icon">' + ICON.gift + '</span><span><b>' + esc(this.data.gift.label) + ' de brinde</b>';
    out += '<span class="fl-gift__price"><s>' + brl(this.data.gift.value) + '</s> Grátis</span></span></div>';
    if (gifts.length > 1) {
      out += '<p class="fl-label">Escolha a cor do cinto: <b>' + esc(g.label) + '</b></p><div class="fl-colors fl-colors--gift" role="radiogroup" aria-label="Cor do brinde">';
      gifts.forEach(function (p, j) {
        out += '<button type="button" class="fl-color" role="radio" aria-checked="' + (j === this.giftIdx) + '" data-g="' + j + '" aria-label="' + esc(p.label) + '" title="' + esc(p.label) + '"><span class="fl-color__img"><img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="56" height="70">' + ICON.tick + '</span><span class="fl-color__name">' + esc(p.label) + '</span></button>';
      }, this);
      out += '</div>';
    }
    wrap.innerHTML = out;
    wrap.hidden = false;
  };

  // Cinto opcional (ofertas sem brinde): card na revisão com "Adicionar" + cores
  Main.prototype.addonItem = function () {
    var a = this.data.addon, o = this.offer();
    if (!o || o.gift || !a.products.length) return null;
    if (a.scope !== 'nogift' && o.slots.length !== 1) return null;
    if (this.addonIdx >= a.products.length) this.addonIdx = 0;
    return a.products[this.addonIdx];
  };

  Main.prototype.renderAddon = function () {
    var wrap = this.q('[data-fl-addon]');
    if (!wrap) return;
    var a = this.data.addon, p = this.addonItem();
    if (!p) { wrap.hidden = true; wrap.innerHTML = ''; this.addonOn = false; return; }
    var price = '<span class="fl-addon__price">' + (p.compare > p.price ? '<s>' + brl(p.compare) + '</s> ' : '') + '<b>' + brl(p.price) + '</b></span>';
    var out = '<div class="fl-addon__head"><img src="' + esc(p.thumb) + '" alt="" width="48" height="60" loading="lazy">' +
      '<span class="fl-addon__txt"><b>' + esc(a.title || 'Leve o cinto') + '</b>' + (a.text ? '<span>' + esc(a.text) + '</span>' : '') + price + '</span>' +
      '<button type="button" class="fl-addon__toggle" data-fl-addon-toggle aria-pressed="' + this.addonOn + '">' + (this.addonOn ? ICON.tick + 'Adicionado' : '+ Adicionar') + '</button></div>';
    if (a.products.length > 1) {
      out += '<div class="fl-colors fl-colors--gift fl-addon__colors" role="radiogroup" aria-label="Cor do cinto">';
      a.products.forEach(function (q, j) {
        out += '<button type="button" class="fl-color" role="radio" aria-checked="' + (this.addonOn && j === this.addonIdx) + '" data-a="' + j + '" aria-label="' + esc(q.label) + '" title="' + esc(q.label) + '"><span class="fl-color__img"><img src="' + esc(q.thumb) + '" alt="" loading="lazy" width="56" height="70">' + ICON.tick + '</span><span class="fl-color__name">' + esc(q.label) + '</span></button>';
      }, this);
      out += '</div>';
    }
    wrap.innerHTML = out;
    wrap.classList.toggle('is-on', this.addonOn);
    wrap.hidden = false;
  };

  // Total exibido = kit + cinto opcional (se marcado)
  Main.prototype.extra = function () {
    var p = this.addonOn ? this.addonItem() : null;
    return p ? p.price : 0;
  };
  // "De / por / economia" da oferta somando o cinto opcional (preço "comparar em" dele, se tiver)
  Main.prototype.view = function (o) {
    var p = this.addonOn ? this.addonItem() : null;
    var total = o.total + (p ? p.price : 0);
    var old = o.old + (p ? Math.max(p.compare, p.price) : 0);
    var save = old - total;
    return { total: total, old: old, save: save, pct: old && save > 0 ? Math.round(save * 100 / old) : 0 };
  };

  // Passo 3: prévia do kit + total + botão
  Main.prototype.renderKit = function () {
    var self = this;
    var o = this.offer();
    var rows = this.picks.map(function (pick, i) {
      var list = self.data.lists[pick.key];
      var prod = list.products[pick.p];
      var v = self.variantOf(pick);
      return '<li><img src="' + esc(prod.thumb) + '" alt="" width="44" height="55"><span><b>' + esc(list.label) + '</b><span>' +
        esc(prod.label) + ' · ' + (v ? 'Tam. ' + esc(v.t) : '<em>falta o tamanho</em>') + '</span></span>' +
        (self.flow ? '<button type="button" class="fl-kit__edit" data-fl-edit="' + i + '">Alterar</button>' : '') + '</li>';
    });
    var gifts = this.data.gift.products;
    if (o.gift && gifts.length) {
      var g = gifts[this.giftIdx] || gifts[0];
      rows.push('<li class="is-gift"><img src="' + esc(g.thumb) + '" alt="" width="44" height="55"><span><b>' + esc(this.data.gift.label) + '</b>' + esc(g.label) + '</span><em class="fl-kit__free">Grátis</em>' +
        (this.flow && gifts.length > 1 ? '<button type="button" class="fl-kit__edit" data-fl-edit="gift">Alterar</button>' : '') + '</li>');
    }
    var ad = this.addonOn ? this.addonItem() : null;
    if (ad) rows.push('<li class="is-addon"><img src="' + esc(ad.thumb) + '" alt="" width="44" height="55"><span><b>' + esc(this.data.addon.title || 'Cinto') + '</b>' + esc(ad.label) + '</span><em class="fl-kit__add">+ ' + brl(ad.price) + '</em></li>');
    var ship = this.shipText(o);
    rows.push('<li class="is-ship"><span class="fl-kit__icon">' + ICON.truck + '</span><span><b>Frete</b>' + esc(ship.text) + '</span>' + (ship.free ? '<em class="fl-kit__free">Grátis</em>' : '') + '</li>');
    this.q('[data-fl-kit]').innerHTML = '<ul role="list">' + rows.join('') + '</ul>';

    var vw = this.view(o);
    var total = vw.total;
    this.q('[data-fl-sum-old]').textContent = vw.save > 0 ? brl(vw.old) : '';
    var off = this.q('[data-fl-sum-off]');
    off.textContent = vw.save > 0 ? '-' + vw.pct + '%' : '';
    off.hidden = !(vw.save > 0);
    this.q('[data-fl-sum-price]').textContent = brl(total);
    this.q('[data-fl-sum-inst]').textContent = 'ou ' + installments(total);
    this.q('[data-fl-sum-save]').innerHTML = vw.save > 0 ? 'Você economiza <b>' + brl(vw.save) + '</b>' : '';

    var missing = this.picks.findIndex(function (p) { return p.v == null; });
    var btn = this.q('[data-fl-buy]');
    var label = this.q('[data-fl-buy-label]');
    btn.classList.toggle('is-pending', missing > -1);
    label.textContent = missing > -1
      ? (this.data.ctaPending || 'Escolha o tamanho da peça [n]').replace('[n]', missing + 1)
      : (o.cta || btn.dataset.label) + ' · ' + brl(total);
    this.updateSticky(missing);
    this.renderUpsell();
  };

  // Frete: grátis no kit, grátis pelo valor (Brasil todo) ou só na região
  Main.prototype.shipText = function (o) {
    var s = this.data.ship || {};
    if (o.free || (s.allMin && o.total >= s.allMin)) return { free: true, text: 'Grátis para todo o Brasil' };
    if (s.regionMin && s.regionLabel && o.total >= s.regionMin) return { free: false, text: 'Grátis no ' + s.regionLabel + ' · demais regiões pelo CEP no checkout' };
    return { free: false, text: 'Calculado no checkout pelo CEP' };
  };

  // Sugere a oferta com 1 peça a mais (mesmas peças + 1)
  Main.prototype.renderUpsell = function () {
    var wrap = this.q('[data-fl-upsell]');
    if (!wrap) return;
    var o = this.offer();
    var up = this.data.upsell && this.offers.filter(function (u) {
      return u.slots.length === o.slots.length + 1 && o.slots.every(function (k, i) { return u.slots[i] === k; });
    })[0];
    if (!up || up.total <= o.total) { wrap.hidden = true; wrap.innerHTML = ''; return; }
    var gains = [];
    if (up.gift && !o.gift && this.data.gift.products.length) gains.push('ganhe o ' + this.data.gift.label);
    if (this.shipText(up).free && !this.shipText(o).free) gains.push('frete grátis');
    gains.push(brl(Math.round(up.total / up.slots.length)) + ' por peça');
    var title = (this.data.upsellText || 'Leve +1 peça por mais [valor]').replace('[valor]', brl(up.total - o.total));
    wrap.innerHTML = '<button type="button" class="fl-upsell__btn" data-fl-upgrade="' + esc(up.id) + '">' +
      '<span class="fl-upsell__plus" aria-hidden="true">+1</span>' +
      '<span class="fl-upsell__txt"><b>' + esc(title) + '</b><span>' + esc(gains.join(' · ')) + '</span></span>' +
      '<span class="fl-upsell__go">' + esc(up.title) + '</span></button>';
    wrap.hidden = false;
    if (!wrap.dataset.bound) {
      var self = this;
      wrap.dataset.bound = '1';
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fl-upgrade]');
        if (!b) return;
        track('upsell_click', { from: self.offer().title });
        self.select(b.dataset.flUpgrade);
      });
    }
  };

  // "Comprando agora, enviamos até [data]" — soma dias úteis
  Main.prototype.dispatch = function () {
    var el = this.q('[data-fl-dispatch]');
    var s = this.data.ship || {};
    if (!el || !s.days || !s.dispatch) return;
    var d = new Date();
    var left = s.days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left--;
    }
    var day = d.toLocaleDateString('pt-BR', { weekday: 'long' });
    var date = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
    el.querySelector('span').innerHTML = esc(s.dispatch).replace('[data]', '<b>' + esc(day) + ', ' + date + '</b>');
    el.hidden = false;
  };

  Main.prototype.renderFrom = function () {
    var el = this.q('[data-fl-from]');
    if (!el || !this.offers.length) return;
    var best = this.offers.reduce(function (a, o) { return o.total / o.slots.length < a.total / a.slots.length ? o : a; });
    el.innerHTML = 'Kits a partir de <b>' + brl(Math.round(best.total / best.slots.length)) + '</b> por peça';
  };

  // ---------- Galeria ----------
  Main.prototype.updateGallery = function () {
    var pick = this.picks[0];
    if (!pick) return;
    var prod = this.data.lists[pick.key].products[pick.p];
    if (!prod || !prod.images.length) return;
    if (this.galleryFor === prod.id) return;
    var firstLoad = this.galleryFor == null;
    this.galleryFor = prod.id;
    var trk = this.q('[data-fl-gallery]');
    // Na 1ª carga mantém as fotos do servidor quando já são do produto aberto
    if (!(firstLoad && this.currentId === prod.id && trk.children.length)) {
      trk.innerHTML = prod.images.map(function (src, j) {
        return '<div class="fl-media__slide"><img src="' + esc(src) + '" alt="' + esc(prod.title) + '"' + (j ? ' loading="lazy"' : '') + ' width="1000" height="1250"></div>';
      }).join('');
      trk.scrollTo({ left: 0 });
    }
    this.thumbs();
  };

  Main.prototype.gallery = function () {
    var self = this;
    var trk = this.q('[data-fl-gallery]');
    if (!trk) return;
    trk.addEventListener('scroll', function () { self.activeSlide(); }, { passive: true });
    var go = function (dir) {
      var i = self.slideIndex() + dir;
      self.goTo(i);
    };
    var prev = this.q('[data-fl-gallery-prev]');
    var next = this.q('[data-fl-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    this.q('[data-fl-gallery-thumbs]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]');
      if (b) self.goTo(+b.dataset.i);
    });
    this.thumbs();
  };

  Main.prototype.slideIndex = function () {
    var trk = this.q('[data-fl-gallery]');
    return Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth));
  };

  Main.prototype.goTo = function (i) {
    var trk = this.q('[data-fl-gallery]');
    var n = trk.children.length;
    i = (i + n) % n;
    trk.scrollTo({ left: i * trk.clientWidth, behavior: 'smooth' });
  };

  Main.prototype.thumbs = function () {
    var trk = this.q('[data-fl-gallery]');
    var wrap = this.q('[data-fl-gallery-thumbs]');
    var imgs = Array.prototype.map.call(trk.querySelectorAll('img'), function (img) { return img.currentSrc || img.src; });
    wrap.innerHTML = imgs.length > 1 ? imgs.map(function (src, i) {
      return '<button type="button" data-i="' + i + '" aria-label="Foto ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '><img src="' + esc(src.replace(/width=\d+/, 'width=200')) + '" alt="" loading="lazy" width="56" height="70"></button>';
    }).join('') : '';
    this.activeSlide();
  };

  Main.prototype.activeSlide = function () {
    var trk = this.q('[data-fl-gallery]');
    var i = this.slideIndex();
    var n = trk.children.length;
    var count = this.q('[data-fl-gallery-count]');
    if (count) { count.textContent = n > 1 ? (i + 1) + ' / ' + n : ''; count.hidden = n < 2; }
    this.el.querySelectorAll('[data-fl-gallery-thumbs] button').forEach(function (b, j) {
      if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  };

  // ---------- Erros e compra ----------
  Main.prototype.hideError = function () { this.q('[data-fl-error]').hidden = true; };
  Main.prototype.showError = function (msg) {
    var err = this.q('[data-fl-error]');
    err.textContent = msg;
    err.hidden = false;
  };

  // Abre e destaca a primeira peça sem tamanho
  Main.prototype.validate = function () {
    var missing = this.picks.findIndex(function (p) { return p.v == null; });
    if (missing < 0) { this.hideError(); return true; }
    this.picks[missing].missing = true;
    if (this.flow) {
      this.go({ t: 'piece', i: missing, ph: 'size' }, true);
      return false;
    }
    this.open = missing;
    this.renderPieces();
    var el = this.q('[data-fl-piece="' + missing + '"]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.remove('is-shake');
      void el.offsetWidth;
      el.classList.add('is-shake');
    }
    return false;
  };

  // mode 'cart' = botão "Adicionar à sacola": não esvazia a sacola nem vai para o checkout
  Main.prototype.buy = function (mode) {
    var self = this;
    var toCart = mode === 'cart';
    var o = this.offer();
    if (!o || this.busy || !this.validate()) return;
    var kitId = o.title + ' · ' + Date.now().toString(36);
    // 1 peça sem brinde vai como compra normal (sem marcação de kit)
    var isKit = this.picks.length > 1 || o.gift || o.discount > 0;
    var items = this.picks.map(function (p) {
      return isKit ? { id: p.v, quantity: 1, properties: { _kit: o.title, _kit_id: kitId } } : { id: p.v, quantity: 1 };
    });
    var gifts = this.data.gift.products;
    if (o.gift && this.data.gift.add && gifts.length) {
      items.push({ id: gifts[this.giftIdx].variant.id, quantity: 1, properties: { _brinde: this.data.gift.label, _kit: o.title, _kit_id: kitId, _kit_pecas: String(this.picks.length) } });
    }
    var ad = this.addonOn ? this.addonItem() : null;
    if (ad) items.push({ id: ad.variant.id, quantity: 1, properties: { _adicional: this.data.addon.title || 'Cinto' } });
    var btns = [this.q('[data-fl-buy]'), this.q('[data-fl-sticky-cta]'), this.q('[data-fl-addcart]')].filter(Boolean);
    this.busy = true;
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var post = function (url, body) {
      return fetch(root + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'Não foi possível adicionar o kit.');
          return json;
        });
      });
    };
    (this.data.clearCart && !toCart ? post('cart/clear.js') : Promise.resolve())
      .then(function () {
        var body = { items: items };
        // botão da sacola: já pede a sacola lateral renderizada (mesmo jeito do tema), para abrir com o kit dentro
        if (toCart && window.BasicCart) { body.sections = 'cart-drawer,promo-nudge'; body.sections_url = window.location.pathname; }
        return post('cart/add.js', body);
      })
      .then(function (added) {
        track('add_to_cart', {
          ecommerce: {
            currency: 'BRL',
            value: o.total / 100,
            items: self.picks.map(function (p) {
              var prod = self.data.lists[p.key].products[p.p];
              return { item_id: String(p.v), item_name: prod.title, item_category: o.title, quantity: 1 };
            })
          }
        });
        if (toCart) { self.addedToCart(btns, added && added.sections); return; }
        if (self.data.afterAdd === 'cart') { window.location.href = root + 'cart'; return; }
        if (typeof window.getNewCheckoutURL === 'function') {
          if (typeof window.showYampiLoader === 'function') window.showYampiLoader();
          window.getNewCheckoutURL();
        } else {
          window.location.href = root + 'checkout';
        }
      })
      .catch(function (e) {
        self.busy = false;
        btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        self.showError(e.message);
      });
  };

  // Kit adicionado pelo botão da sacola: libera os botões, confirma e abre a sacola (ou fica / vai para /cart)
  Main.prototype.addedToCart = function (btns, sections) {
    this.busy = false;
    btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
    var after = this.data.cartAfter || 'drawer';
    if (after === 'cart') { window.location.href = root + 'cart'; return; }
    var btn = this.q('[data-fl-addcart]');
    var label = this.q('[data-fl-addcart-label]');
    if (btn && label && btn.dataset.done) {
      btn.classList.add('is-done');
      label.textContent = btn.dataset.done;
      clearTimeout(this.doneTimer);
      this.doneTimer = setTimeout(function () { btn.classList.remove('is-done'); label.textContent = btn.dataset.label; }, 3500);
    }
    var cart = window.BasicCart;
    if (cart) {
      cart.render(sections).then(function () {
        if (after === 'drawer' && cart.drawer) cart.open();
      });
    }
    if (this.flow) this.go({ t: 'kit' }, true);
    else {
      var kit = this.q('.fl-builder');
      if (kit && after === 'stay') kit.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // ---------- Barra fixa ----------
  Main.prototype.sticky = function () {
    var self = this;
    var bar = this.q('[data-fl-sticky]');
    if (!bar) return;
    bar.querySelector('[data-fl-sticky-cta]').addEventListener('click', function () { self.buy(); });
    var builder = this.q('.fl-builder');
    if (!('IntersectionObserver' in window) || !builder) return;
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-sticky-buy', show);
    }, { threshold: 0, rootMargin: '0px 0px -30% 0px' }).observe(builder);
  };

  Main.prototype.updateSticky = function (missing) {
    var bar = this.q('[data-fl-sticky]');
    if (!bar) return;
    var self = this;
    var o = this.offer();
    bar.querySelector('[data-fl-sticky-thumbs]').innerHTML = this.picks.slice(0, 3).map(function (pick) {
      var prod = self.data.lists[pick.key].products[pick.p];
      return prod ? '<img src="' + esc(prod.thumb) + '" alt="" width="36" height="45">' : '';
    }).join('');
    bar.querySelector('[data-fl-sticky-kit]').textContent = o.title + (o.free ? ' · frete grátis' : (o.gift ? ' · cinto grátis' : ''));
    var vw = this.view(o);
    bar.querySelector('[data-fl-sticky-old]').textContent = vw.save > 0 ? brl(vw.old) : '';
    bar.querySelector('[data-fl-sticky-price]').textContent = brl(vw.total);
    bar.classList.toggle('is-pending', missing > -1);
  };

  // ---------- Guia de medidas (gaveta) ----------
  Main.prototype.guide = function () {
    var self = this;
    var dlg = this.q('[data-fl-guide]');
    if (!dlg) return;
    this.closeGuide = function () {
      dlg.classList.add('is-closing');
      setTimeout(function () { dlg.classList.remove('is-closing'); if (dlg.open) dlg.close(); }, 200);
    };
    this.el.querySelectorAll('[data-fl-guide-open]').forEach(function (b) { b.addEventListener('click', function () { self.openGuide(-1); }); });
    dlg.querySelector('[data-fl-guide-close]').addEventListener('click', this.closeGuide);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) self.closeGuide(); });
    this.calc();
  };

  Main.prototype.openGuide = function (piece) {
    var dlg = this.q('[data-fl-guide]');
    if (!dlg) return;
    this.guideFor = piece;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    if (this.calcUpdate) this.calcUpdate();
    track('size_guide_open', { piece: piece + 1 });
  };

  // Calculadora: lê a tabela do guia (colunas Busto/Cintura/Quadril com faixas "85-90")
  Main.prototype.calc = function () {
    var self = this;
    var box = this.q('[data-fl-calc]');
    var table = this.q('[data-fl-mtable] table');
    if (!box || !table) return;
    var trs = Array.prototype.slice.call(table.querySelectorAll('tr'));
    if (trs.length < 2) return;
    var norm = function (t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); };
    var head = Array.prototype.map.call(trs[0].children, function (c) { return norm(c.textContent); });
    var cols = [];
    ['busto', 'cintura', 'quadril'].forEach(function (name) {
      var idx = head.findIndex(function (h) { return h.indexOf(name) > -1; });
      if (idx > -1) cols.push({ name: name, idx: idx });
    });
    var rows = trs.slice(1).map(function (tr) {
      var cells = Array.prototype.map.call(tr.children, function (c) { return c.textContent.trim(); });
      var r = { size: cells[0], ranges: {} };
      cols.forEach(function (c) {
        var m = (cells[c.idx] || '').match(/(\d+(?:[.,]\d+)?)\s*[-–a]+\s*(\d+(?:[.,]\d+)?)/);
        if (m) r.ranges[c.name] = [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))];
      });
      return r;
    }).filter(function (r) { return r.size && Object.keys(r.ranges).length; });
    if (!cols.length || !rows.length) return;
    var labels = { busto: 'Busto', cintura: 'Cintura', quadril: 'Quadril' };
    this.q('[data-fl-calc-fields]').innerHTML = cols.map(function (c) {
      return '<label class="fl-calc__field"><span>' + labels[c.name] + '</span><span class="fl-calc__input"><input type="number" inputmode="decimal" min="40" max="200" step="1" placeholder="—" data-calc="' + c.name + '"><em>cm</em></span></label>';
    }).join('');
    var result = this.q('[data-fl-calc-result]');
    var update = this.calcUpdate = function () {
      var vals = {};
      box.querySelectorAll('[data-calc]').forEach(function (inp) {
        var v = parseFloat(inp.value);
        if (v > 0) vals[inp.dataset.calc] = v;
      });
      var keys = Object.keys(vals);
      if (!keys.length) { result.innerHTML = '<span class="fl-calc__hint">Coloque suas medidas para ver o tamanho indicado.</span>'; return; }
      var fits = function (r, strict) {
        return keys.every(function (k) { var g = r.ranges[k]; return !g || (strict ? vals[k] >= g[0] && vals[k] <= g[1] : vals[k] <= g[1]); });
      };
      // Dentro da faixa: fica com o maior; senão, o menor que comporta todas as medidas
      var exact = rows.filter(function (r) { return fits(r, true); });
      var best = exact.length ? exact[exact.length - 1] : rows.filter(function (r) { return fits(r, false); })[0];
      if (!best) { result.innerHTML = '<span class="fl-calc__hint">Suas medidas passam da nossa tabela. Fale com a gente no WhatsApp que a gente te ajuda.</span>'; return; }
      var target = self.guideFor > -1 ? self.guideFor : Math.max(0, self.picks.findIndex(function (p) { return p.v == null; }));
      var out = '<span class="fl-calc__size">Seu tamanho: <b>' + esc(best.size) + '</b></span>';
      if (exact.length > 1) out += '<span class="fl-calc__hint">Ficou entre ' + esc(exact[0].size) + ' e ' + esc(best.size) + ': indicamos o maior pela modelagem solta.</span>';
      if (self.data.calcPick && self.picks[target]) out += '<button type="button" class="fl-calc__use" data-calc-use="' + esc(best.size) + '" data-calc-piece="' + target + '">Usar o ' + esc(best.size) + ' na peça ' + (target + 1) + '</button>';
      result.innerHTML = out;
    };
    box.addEventListener('input', update);
    result.addEventListener('click', function (e) {
      var b = e.target.closest('[data-calc-use]');
      if (!b) return;
      var i = +b.dataset.calcPiece;
      var pick = self.picks[i];
      var prod = self.data.lists[pick.key].products[pick.p];
      var wanted = b.dataset.calcUse.split('/').map(function (t) { return t.trim(); });
      var v = prod.variants.filter(function (x) { return x.a && wanted.indexOf(x.t) > -1; })[0];
      if (!v) { result.insertAdjacentHTML('beforeend', '<span class="fl-calc__hint is-err">Esse tamanho está esgotado nesta cor. Escolha outra cor na peça ' + (i + 1) + '.</span>'); return; }
      pick.v = v.id;
      pick.missing = false;
      track('size_calc_use', { piece: i + 1, size: v.t });
      var next = self.picks.findIndex(function (p) { return p.v == null; });
      self.open = next;
      self.renderPieces();
      self.renderKit();
      self.hideError();
      self.closeGuide();
    });
    box.hidden = false;
    update();
  };

  // ---------- Resumo das ofertas (seção "Kit · resumo ofertas") ----------
  Main.prototype.recapCard = function (o) {
    var self = this;
    var seen = {};
    var imgs = o.slots.map(function (key) {
      var n = seen[key] = (seen[key] == null ? 0 : seen[key] + 1);
      var list = self.data.lists[key];
      var p = list.products[self.firstIdx(list, list.groups[0] || '', n, self.currentId)];
      return p ? '<img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="64" height="80">' : '';
    });
    var gifts = this.data.gift.products;
    if (o.gift && gifts.length) imgs.push('<img class="is-gift" src="' + esc(gifts[0].thumb) + '" alt="' + esc(this.data.gift.label) + ' de brinde" loading="lazy" width="64" height="80">');
    var perks = '';
    if (o.gift && gifts.length) perks += '<li>' + ICON.gift + esc(this.data.gift.label) + ' grátis</li>';
    perks += '<li>' + ICON.truck + (o.free ? 'Frete grátis' : 'Frete calculado no CEP') + '</li>';
    return '<article class="fl-final-card' + (o.badge ? ' has-badge' : '') + '">' +
      (o.badge ? '<span class="fl-offer__badge fl-offer__badge--' + esc(o.badgeStyle) + '">' + esc(o.badge) + '</span>' : '') +
      '<div class="fl-final-card__imgs">' + imgs.join('') + '</div>' +
      '<b class="fl-final-card__title">' + esc(o.title) + '</b>' +
      (o.subtitle ? '<span class="fl-final-card__sub">' + esc(o.subtitle) + '</span>' : '') +
      '<div class="fl-final-card__prices">' + (o.save > 0 ? '<s>' + brl(o.old) + '</s>' : '') + '<strong>' + brl(o.total) + '</strong>' + (o.pct ? '<span class="fl-total__off">-' + o.pct + '%</span>' : '') + '</div>' +
      '<span class="fl-final-card__inst">ou ' + installments(o.total) + '</span>' +
      '<ul class="fl-final-card__perks" role="list">' + perks + '</ul>' +
      '<a class="fl-final-card__cta" href="#comprar" data-fl-goto="' + esc(o.id) + '">' + esc(o.cta || 'Quero este kit') + '</a>' +
      '</article>';
  };

  function initRecaps(main) {
    document.querySelectorAll('[data-fl-recap]').forEach(function (wrap) {
      wrap.innerHTML = main.offers.map(main.recapCard, main).join('');
      if (wrap.dataset.flReady) return;
      wrap.dataset.flReady = '1';
      wrap.addEventListener('click', function (e) {
        var a = e.target.closest('[data-fl-goto]');
        if (!a) return;
        e.preventDefault();
        main.select(a.dataset.flGoto);
        main.q('.fl-builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var main = null;
    document.querySelectorAll('[data-fl-main]').forEach(function (el) {
      if (!el.flMain) {
        try { el.flMain = new Main(el); } catch (e) { console.error('[fl-lp]', e); }
      }
      main = main || el.flMain;
    });
    if (!main) return;
    initRecaps(main);
    // Links com data-fl-select escolhem uma oferta pelo nome e voltam ao montador
    document.querySelectorAll('[data-fl-select]').forEach(function (a) {
      if (a.dataset.flBound) return;
      a.dataset.flBound = '1';
      a.addEventListener('click', function (e) {
        var o = main.offers.filter(function (x) { return x.title === a.dataset.flSelect; })[0];
        if (!o) return;
        e.preventDefault();
        main.select(o.id);
        main.q('.fl-builder').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  window.FlLp = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Editor de temas: re-inicializa quando a seção é recarregada
  document.addEventListener('shopify:section:load', init);
})();
